<template>
  <v-app>
    <v-app-bar app clipped-right flat height="72" color="navy lighten-3">
      <v-spacer />
      <UserMenu />
    </v-app-bar>
    <v-navigation-drawer app :width="360">
      <Drawer />
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Drawer from "./Drawer.vue"
import UserMenu from "./UserMenu.vue"

export default {
  components: {
    Drawer,
    UserMenu,
  },
}
</script>
